<template>
  <div>
    <backdrop-loader :isLoading="loading" />
    <div class="header">
      <h1 style="margin: 0; display: block">Price Playground</h1>
      <formula-tips />
    </div>
    <hr class="solid-separator" />
    <div class="pc-control-section">
      <formula-errors :errors="errors" />
      <formula-price :pricing-details="pricingDetails" />
      <button
        class="btn v2_btn v2_btn-primary v2_btn-transparent"
        v-on:click="onPriceCheckHandler"
        :disabled="loading"
      >
        Check Price
      </button>
    </div>
    <Split style="height: 70vh">
      <SplitArea :size="50">
        <div class="split-area-container">
          <h2 style="margin-top: 0">Event</h2>
          <event-lookup :event.sync="event" :is-price-check="true" />
          <event-editor :event.sync="event" />
        </div>
      </SplitArea>
      <SplitArea :size="50">
        <div class="split-area-container">
          <h2 style="margin-top: 0">Formula</h2>
          <formula-rich-editor :formula.sync="formula"/>
        </div>
      </SplitArea>
    </Split>
  </div>
</template>

<script>
import VueSplit from "vue-split-panel";
import {mapGetters, mapState, mapActions} from "vuex";

import store from "./store";
import PriceMixin from "./shared/formula.mixin";
import FormulaTips from "./shared/tips.vue";
import EventLookup from "./shared/event/lookup.vue";
import EventEditor from "./shared/event/editor.vue";
import FormulaPrice from "./shared/price.vue";
import FormulaErrors from "./shared/header-errors.vue";
import FormulaRichEditor from "./shared/formula-rich-editor.vue";
import BackdropLoader from "../utils/backdrop-loader.vue";

Vue.use(VueSplit);

export default {
  store,
  components: {
    EventLookup,
    EventEditor,
    FormulaTips,
    FormulaPrice,
    FormulaErrors,
    FormulaRichEditor,
    BackdropLoader,
  },
  mixins: [PriceMixin],
  name: "PriceCheck",
  props: {
    formulaId: {
      default: null,
      require: false,
    },
    pipelineSlug: {
      default: null,
      required: false,
    },
  },
  data() {
    return {
      isValid: false,
      errors: null,
      formula: "",
      event: "",
    };
  },
  computed: {
    ...mapGetters(["variables"]),
    ...mapState(["loading", "formulaEntity", "pricingDetails"]),
  },
  methods: {
    ...mapActions(["checkPrice", "fetchFormula"]),
    onPriceCheckHandler: async function () {
      this.errors = this.validateCheckPriceForm(this.event, this.formula);

      if (this.errors.length > 0) {
        this.$store.commit("setPricingDetails", null);
        return;
      }

      try {
        await this.checkPrice({event: this.event, formula: this.formula});
      } catch (error) {
        if ((error.message = "FormulaExecutionFailure")) {
          this.errors = error.cause;
          return;
        }
      }
    },
    async loadFormula() {
      if (this.$store.state.pipelineSlug && this.$store.state.formulaId) {
        await this.fetchFormula({
          formulaId: this.$store.state.formulaId,
          pipelineSlug: this.$store.state.pipelineSlug,
        });

        this.formula = this.formulaEntity.formula;
      }
    },
  },
  created() {
    this.$store.commit("setFormulaId", this.formulaId);
    this.$store.commit("setPipelineSlug", this.pipelineSlug);

    this.loadFormula();
  },
};
</script>

<style>
.split .gutter.gutter-horizontal:hover {
  transform: scale(1.15);
  transition: all 0.2s ease;
}
</style>

<style scoped>
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 16px;
}

.solid-separator {
  margin-left: 24px;
  margin-right: 24px;
  box-shadow: 0 1em 1em -1em rgba(0, 0, 0, 0.25);
}
.split-area-container {
  display: flex;
  overflow: hidden;
  height: 100%;
  flex-direction: column;
  transition: width 0.5s;
  padding: 0 16px 10px 16px;
  min-width: 640px;
}

.v2_btn-primary {
  border: solid #4e63ff 1px;
}

.v2_btn-transparent {
  background: transparent;
}

.v2_btn {
  cursor: pointer;
}

.v2_btn:hover {
  transform: scale(1.015);
  animation: 500ms ease-in-out forwards;
}

.pc-control-section {
  gap: 16px;
  display: flex;
  margin: 0 20px;
  justify-content: flex-end;
}
</style>
